import React from 'react'
import { AiOutlineArrowRight } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';

const Loginpage = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => navigate(`/${path}`);


  return (
   
   <div className=' flex flex-col justify-center items-center align-middle bg-gradient-to-tl from-red-100 via-blue-100 to-gray-50' style={{height:100+'vh'}}>
    <div className='WebsiteName italic animate-flip-up animate-duration-[2000ms] text-4xl mb-3' >Your Genie</div> 

 <div className='bg-white w-80 p-6 sm:mx-3 md:mx-0 lg:mx-0 xl:mx-0 2xl:mx-0 rounded  shadow-lg products italic uppercase'>
    <div className='flex items-center justify-center align-middle'>
        <span className='font-semibold'>Login</span>
    </div>
 

            <div class="mb-4 mt-6 animate-fade-right">
                <label for="email" class="block text-gray-700 text-sm  mb-2">Email</label>
                <input type="email" id="email" name="email"
                    class=" text-sm w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-indigo-500"
                />
            </div>
            <div class="mb-4 animate-fade-right animate-delay-300">
                <label for="password" class="block text-gray-700 text-sm mb-2">Password</label>
                <input type="text" id="password" name="password"
                    class=" w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none text-sm focus:border-indigo-500"
                />
            </div>
            

    <div className='mt-3 flex items-center justify-center'>
        <button className='animate-shake rounded w-16 flex items-center justify-center bg-black  text-white py-2 px-2' onClick={()=>handleNavigation(`homepage`)}>
            <AiOutlineArrowRight/>
        </button>
    </div>
    
 </div>
    

    <div className='mt-4 products italic' >New user? <b className='underline cursor-pointer' onClick={()=>handleNavigation('register')}>register here</b></div>
   </div>
  )
}

export default Loginpage